import React from 'react'
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Input } from 'antd';
import BoletoService from 'services/boleto'
import { message } from 'antd'

const FormItem = Form.Item

function EmailModal(props) {
  const { getFieldDecorator } = props.form
  const { visible, onCancel, idintegracao } = props
  const [loading, setLoading] = React.useState(false)

  async function sendMail(email) {
    try {
      props.form.validateFields(async (err, values) => {
        if (err) {
          return
        }

        const params = {
          idintegracao: idintegracao,
          email: values.email
        }

        setLoading(true)
        const response = await BoletoService.email(params)
        setLoading(false)

        if (response.status === 200) {
          message.success('E-mail enviado com sucesso.')
        }

        props.form.resetFields()
        onCancel()
      })
    } catch (error) {
      console.log(error);
      setLoading(false)
      let errorMessage = 'Erro ao enviar e-mail.'
      if (
        error.response &&
        error.response.data &&
        error.response.data.errors.errorMessage &&
        typeof error.response.data.errors.errorMessage.content === 'string'
      ) {
        errorMessage = error.response.data.errors.errorMessage.content
      }
      message.error(errorMessage)
    }
  }

  return (
    <Modal
      visible={visible}
      title="Insira o endereço de e-mail"
      okText="Enviar"
      onCancel={onCancel}
      onOk={sendMail}
      centered
    >
      <Form style={{ padding: '24px' }} >
        <FormItem label="E-mail">
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Por favor insira um e-mail' },
            { type: 'email', message: 'O e-mail informado não é válido!' }
            ],
          })(
            <Input />
          )}
        </FormItem>
      </Form>
    </Modal>
  );

}

export default Form.create({})(EmailModal)